export const ALL_FILES_OPTION_ID = '__all__';
export const ALL_FILES_LABEL = 'All files';
export const VIEW_DOCUMENT_LABEL = 'View Document:';
export const DELETE_FILE_LABEL = 'Delete File';
export const DELETE_SUCCESS_MESSAGE = 'Deleted successfully';

export const PROVISIONAL_FILE_ENDPOINTS = {
    FILE_LIST: '/mis/provisional-docs-ingestion-status',
    FILE_STATEMENT: '/financials/dateRange',
    NOT_INGESTED_COUNT: '/unifier/getProvisionalNotIngestedCount',
} as const;

export const PROVISIONAL_INGESTION_NOUN = { singular: 'provisional file', plural: 'provisional files' } as const;

/** Byte-identical to the underwriting engine's CommonConstants misDisplayName values for the two per-file statements. */
export const PROVISIONAL_FILE_VIEW_MIS = {
    balanceSheet: 'Balance Sheet',
    profitAndLoss: 'Profit And Loss',
} as const;

export const PROVISIONAL_FILE_VIEW_STATUS = {
    VIEWABLE: 'VIEWABLE',
    PENDING: 'PENDING',
    FAILED: 'FAILED',
    NO_STATEMENTS: 'NO_STATEMENTS',
    NOT_PARSED: 'NOT_PARSED',
} as const;

export const PROVISIONAL_FILE_STATUS_CHIP: Record<string, string> = {
    [PROVISIONAL_FILE_VIEW_STATUS.PENDING]: 'Processing',
    [PROVISIONAL_FILE_VIEW_STATUS.FAILED]: 'Failed',
    [PROVISIONAL_FILE_VIEW_STATUS.NO_STATEMENTS]: 'No BS/P&L',
    [PROVISIONAL_FILE_VIEW_STATUS.NOT_PARSED]: 'Not parsed',
};

export const PROVISIONAL_FILE_STATUS_MESSAGE: Record<string, string> = {
    [PROVISIONAL_FILE_VIEW_STATUS.PENDING]:
        'This file is still being processed. Balance Sheet and Profit & Loss will appear once extraction completes.',
    [PROVISIONAL_FILE_VIEW_STATUS.FAILED]: "We couldn't extract a Balance Sheet or Profit & Loss from this file.",
    [PROVISIONAL_FILE_VIEW_STATUS.NO_STATEMENTS]: 'This file has no Balance Sheet or Profit & Loss data.',
    [PROVISIONAL_FILE_VIEW_STATUS.NOT_PARSED]: "This file hasn't been parsed yet.",
};

export const PROVISIONAL_FILE_UNKNOWN_STATUS_CHIP = 'Unavailable';
export const PROVISIONAL_FILE_UNKNOWN_STATUS_MESSAGE = "This file can't be shown here yet.";

export const PROVISIONAL_FILE_NATURE_NOTE = (label: string) =>
    `This file has only ${label} data, so its Balance Sheet and Profit & Loss show ${label} figures.`;

export const PROVISIONAL_FILE_DELETE_CONFIRM = {
    title: 'Delete this file?',
    subTitle: (displayName: string) =>
        `"${displayName}" will be deleted from the Data Room and its figures removed from Provisional Financials. This cannot be undone.`,
    confirmCta: 'Delete',
    cancelCta: 'Cancel',
};

/** One fixed id, so a Balance Sheet + P&L double failure shows a single toast. */
export const PROVISIONAL_FILE_VIEW_ERROR_TOAST_ID = 'provisional-file-view-error';
